import { defineComponent } from 'vue';
import './index.less';
import { Plugin } from '@vue/runtime-dom';
interface Props {
  title: string;
}

const titleline = defineComponent({
  props: {
    title: { type: String, require: true, default: '' },
  },
  setup(props: Props) {
    return () => (
      <div class="title-line">
        <div class="line"></div>
        <span class="title">{props.title}</span>
      </div>
    );
  },
});

export const DTitleLine: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DTitleline', titleline);
  },
};
